import React from 'react'
import { Navigate } from 'react-router-dom';
import { ACCESS_TOKEN } from '../common/local-storage/Contants';
import { isAccessTokenExpire } from '../common/utils/validate';

function Authorize({ children }) {
    
    let token =  localStorage.getItem(ACCESS_TOKEN)

    // const pathname = window.location.pathname 


// alert('adsds')
    if(token === null || isAccessTokenExpire(token))
    { 
        return <Navigate to="/login" replace />;
    }
    // else if(!isAccessTokenExpire(token) && pathname === '/login')
    // {
    //     alert('asddas')
    //     return <Navigate to="/" replace />;
    // }


    return children;

}

export default Authorize